import { useSearchParams } from "react-router";

const languages = ["en", "ja"];

export type Language = (typeof languages)[number];

export const useLanguage = (): [Language, (lang: Language) => void] => {
	const [searchParams, setSearchParams] = useSearchParams();
	const setLanguage = (lang: Language) => setSearchParams({ lang });
	const lang = searchParams.get("lang") ?? "en";
	if (languages.includes(lang)) return [lang, setLanguage];
	return ["en", setLanguage];
};
